export default __webpack_public_path__ + "static/6628-246e5236e7c10b0e7a7d8a3bfaa251cf.jpg";